import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function Loader() {
  const { t } = useTranslation('common');

  return (
    <div className="text-center">
      <Loader2 className="h-8 w-8 animate-spin text-gray-400 mx-auto mb-4" />
      <p className="text-gray-600">{t('loading')}</p>
    </div>
  );
}
